// extracted by mini-css-extract-plugin
export default {"ourSolution":"responsiveStyles_ourSolution__HMK3X","threeSteps":"responsiveStyles_threeSteps__lJPxh"};